<template>
  <header class="bg-[#1E1E1E]">
    <div class="max-w-7xl mx-auto">
      <div class="flex items-center py-4 justify-between">
        <div>
          <router-link to="/"
            ><img src="@/assets/landing/logo-husky.png"
          /></router-link>
        </div>
        <div>
          <a
            href="/register"
            class="bg-gradient-to-l text-xl from-darkGreen to-lightGreen text-white font-semibold py-2 px-6 rounded-md"
            >Join Now
          </a>
        </div>
      </div>
    </div>
  </header>

  <section class="bg-gradient-to-r from-lightGreen  to-darkGreen p-2  min-h-[800px] features relative hidden md:block">
    <div class="absolute flex min-h-[779px] min-w-[749px]">
      <div class="w-full flex min-h-full rounded-br-full rounded-bl-full relative -top-2 -left-2 header-img-bg"
        style=""></div>
      <!-- <img class="absolute" src="assets/tasker.png"/> -->
    </div>
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-12">
        <div class="col-span-7"></div>
        <div class="col-span-5 pt-4 relative z-10">
          <h1 class="text-white text-[80px] leading-none font-bold">Turn your skils into cash with HuskyTask</h1>
          <p class="text-white text-2xl font-normal py-4">Become a tasker to find freelance jobs in Halifax, Nova
            Scotia. Sign up for free to join our waitlist.
          </p>
          <div class="bg-gradient-to-r from-[#03D7BC] to-darkGreen px-8 py-12 w-[90%] mx-auto shadow-md rounded-xl">
            <form class="flex flex-col space-y-6">
              <input type="text" placeholder="Name" class="rounded-full py-2 px-6 bg-white w-full">
              <input type="email" placeholder="Email" class="rounded-full py-2 px-6 bg-white w-full">
              <div class="my-2"></div>
              <button class="bg-[#FFA500]  text-white text-3xl py-2 px-4 rounded-full text-center  mx-auto"
                type="submit">Claim your spot</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="md:hidden bg-gradient-to-b from-lightGreen  to-darkGreen">
    <div class="bg-[#E5EFDF] rounded-br-full rounded-bl-full pt-4">
      <h1 class="text-[#23C6AC] text-[50px] text-center leading-none font-bold">Turn your skils into cash with HuskyTask
      </h1>
      <p class="text-[#514D59] text-base text-center font-normal py-4">Become a tasker to find freelance jobs in Halifax,
        Nova
        Scotia. Sign up for free to join our waitlist.
      </p>
      <img src="@/assets/landing/header-tasker.png" alt="">
    </div>
    <div class=" bg-[#03D7BC] -top-40 z-10 relative px-4 py-6 w-[80%] mx-auto shadow-md rounded-xl">
      <form class="flex flex-col space-y-4">
        <input type="text" placeholder="Name" class="rounded-full py-2 px-6 bg-white w-full">
        <input type="email" placeholder="Email" class="rounded-full py-2 px-6 bg-white w-full">
        <button class="bg-[#FFA500]  text-white text-xl py-2 px-4 rounded-full text-center  mx-auto"
          type="submit">Claim your spot</button>
      </form>
    </div>
  </section>
  <!-- ============== -->
  <section class="px-4 md:px-0 md:pt-40">
    <div class="grid md:grid-cols-12 space-x-4 max-w-7xl mx-auto">
      <div class="md:col-span-6">
        <div class="flex flex-col mt-8 md:max-w-md space-y-6">
          <h1 class="text-[#23C6AC] text-4xl md:text-6xl font-bold">Experience the HuskyTask advantage</h1>
          <p class="text-[#465864] text-2xl">HuskyTask will help you find jobs that match your skills and schedule. It’s
            never been easier to earn money on your own terms. </p>
        </div>
      </div>
      <div class="md:col-span-6 pt-4">
        <div class="grid md:grid-cols-2 align-top content-start gap-x-4 gap-y-6">
          <div class="max-w-[260px] mx-auto flex justify-center items-center space-y-4 flex-col ">
            <div class="rounded-xl overflow-hidden"><img class="w-[100px] h-[100px]" src="@/assets/landing/calendar-icon.png">
            </div>
            <h2 class="font-bold text-xl text-[#514D59]">Control your schedule</h2>
            <p class="text-[#514D59] text-center text-base">You have the freedom to work as much as you want, and when
              you want.</p>
          </div>
          <div class="max-w-[260px] mx-auto flex justify-center items-center space-y-4 flex-col ">
            <div class="rounded-xl overflow-hidden"><img class="w-[100px] h-[100px]" src="@/assets/landing/speaker-icon.png">
            </div>
            <h2 class="font-bold text-xl text-[#514D59]">Expand your reach</h2>
            <p class="text-[#514D59] text-center text-base">We connect you to thousands of customers in the Halifax area
              by promoting your services for free.</p>
          </div>
          <div class="max-w-[260px] mx-auto flex justify-center items-center space-y-4 flex-col ">
            <div class="rounded-xl overflow-hidden"><img class="w-[100px] h-[100px]" src="@/assets/landing/money-icon.png"></div>
            <h2 class="font-bold text-xl text-[#514D59]">Set your own rates</h2>
            <p class="text-[#514D59] text-center text-base">You determine which tasks to take on and your rate for each
              task.</p>
          </div>

          <div class="max-w-[260px] mx-auto flex justify-center items-center space-y-4 flex-col ">
            <div class="rounded-xl overflow-hidden"><img class="w-[100px] h-[100px]" src="@/assets/landing/setting-icon.png">
            </div>
            <h2 class="font-bold text-xl text-[#514D59]">All-in-one platform</h2>
            <p class="text-[#514D59] text-center text-base">Our online platform is easy to use and handles all the
              logistics–like finding jobs, scheduling, and client communication. </p>
          </div>

        </div>
      </div>
    </div>
  </section>

  <!-- ======= -->
  <section style="" class="bg-no-repeat bg-cover shape-bg relative">

    <div class="max-w-7xl mx-auto pl-4 md:px-0 drill">
      <!-- <img src="@/assets/landing/drill.png" alt="" class="hidden md:block absolute -top-7 rotate-[8deg]" enter-class=""> -->
      <div class="grid items-end  grid-cols-12 md:space-x-4">
        <div class="col-span-6 md:col-span-8 text-white text-sm md:text-3xl pb-6 font-light">
          <p class="italic">“At HuskyTask, we understand that our taskers are at the core of our platform. We’re
            committed to providing
            the support they need to connect with more clients and manage their business, so they can focus on what they
            do best.”
          </p>
          <p class="text-right">The HuskyTask Team</p>
        </div>
        <div class="col-span-6 md:col-span-4 pt-20">
          <img class="-mb-[26px] hidden md:block"
            src="@/assets/landing/ceo-headshot.png"
            alt="Mohamed Rageh, CEO">
            <img class="relative md:hidden"
            src="@/assets/landing/ceo-headshot-mobile.png"
            alt="Mohamed Rageh, CEO">
        </div>
      </div>
    </div>
  </section>

  <section class=" py-10 md:py-40 ">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-12 ">
        <div class="col-span-12">
          <h1 class="text-[#23C6AC] text-3xl md:text-6xl mb-8 pb-8 font-bold text-center">Getting started is easy</h1>
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-12 space-y-12 md:space-y-6 md:space-x-4 px-4 md:px-0 text-center md:text-left">

        <div class="md:col-span-4">
          <div class="flex justify-center items-center">
            <div class="grid md:grid-cols-2 items-center md:gap-x-4 gap-y-4 md:gap-y-0">
              <div>
                <img src="@/assets/landing/step-1.png" alt="" class="mx-auto w-[300px]">
              </div>
              <div>
                <h3 class="font-semibold text-4xl text-[#514D59]">Register</h3>
                <p class="text-[#514D59] text-xl">Fill out our form to complete the easy registration process.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="md:col-span-4">
          <div class="flex justify-center items-center">
            <div class="grid md:grid-cols-2 items-center md:gap-x-4 gap-y-4 md:gap-y-0">
              <div>
                <img src="@/assets/landing/step-2.png" alt="" class="mx-auto w-[300px]">
              </div>
              <div>
                <h3 class="font-semibold text-4xl text-[#514D59]">Join our waitinglist</h3>
                <p class="text-[#514D59] text-xl">As soon as you register, you’ll secure a spot on our waitlist.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="md:col-span-4">
          <div class="flex justify-center items-center">
            <div class="grid md:grid-cols-2 items-center md:gap-x-4 gap-y-4 md:gap-y-0">
              <div class="">
                <img src="@/assets/landing/step-3.png" alt="" class="mx-auto w-[300px]">
              </div>
              <div>
                <h3 class="font-semibold text-4xl text-[#514D59]">Stay Tuned</h3>
                <p class="text-[#514D59] text-xl">Check your email for launch updates and essential information to
                  kickstart your tasking journey when
                  our platform goes live.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
  <!-- ========= -->

  <section
    style=""
    class="bg-no-repeat form-bg-img">
    <div class="py-16"
      style="background: linear-gradient(30deg, #002F27 0%, rgba(0, 0, 0, 0.00) 51.32%); background: rgba(36, 106, 98, 0.84);">
      <div class="max-w-7xl mx-auto px-4 md:px-0">
        <div class="grid md:grid-cols-12 md:space-x-4 space-y-6">
          <div class="col-span-12 md:col-span-8 flex items-end ">
            <h1 class="text-4xl md:text-6xl text-white drop-shadow-md leading-tight font-bold ">Ready to be your own boss? Sign up
              today to start earning more with HuskyTask. </h1>
          </div>
          <div class="col-span-12 md:col-span-4">
            <div class=" px-8 md:py-12 py-6 w-[90%] mx-auto shadow-md rounded-xl" style="background: linear-gradient(136deg, rgba(0, 234, 196, 0.64) 0%, rgba(0, 234, 196, 0.00) 100%);
          ">
              <form class="flex flex-col md:space-y-6 space-y-4">
                <input type="text" placeholder="Name" class="rounded-full py-2 px-6 bg-white w-full">
                <input type="email" placeholder="Email" class="rounded-full py-2 px-6 bg-white w-full">
                <div class="my-2 hidden md:block"></div>
                <button class="bg-[#FFA500]  text-white text-xl md:text-3xl py-2 px-4 rounded-full text-center  mx-auto"
                  type="submit">Claim your spot</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ -->

  <section>
    <div class="max-w-7xl mx-auto py-12 px-4 md:px-0 md:py-40">
      <div class="grid grid-cols-1 md:grid-cols-12">
        <div class="md:col-span-7 order-2 pt-8 md:pt-0 md:order-1">
          <img src="@/assets/landing/cat-img.png" alt="">
        </div>
        <div class="md:col-span-5 order-1 md:order-2">
          <h1 class="text-[#23C6AC] text-5xl md:text-6xl mb-8 pb-8 font-bold">Find tasks that match your skill set</h1>
          <div class="grid gap-4 grid-cols-3 sm:grid-cols-2 mt-6 text-center ">
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/housekeeping.png" alt="">
              </div>
              <h4 class="text-[#514D59] md:text-left font-bold text-sm sm:text-2xl">Housekeeping</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/transportation.png" alt="">
              </div>
              <h4 class="text-[#514D59] font-bold md:text-left text-sm sm:text-2xl">Transportation</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row md:items-start  items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/yard.png" alt="">
              </div>
              <h4 class="text-[#514D59] font-bold md:text-left text-sm sm:text-2xl">Yard maintenance</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/funiture.png" alt="">
              </div>
              <h4 class="text-[#514D59] md:text-left font-bold text-sm sm:text-2xl">Furniture assembly</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/plumbing.png" alt="">
              </div>
              <h4 class="text-[#514D59] md:text-left font-bold text-sm sm:text-2xl">Plumbing work</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/moving.png" alt="">
              </div>
              <h4 class="text-[#514D59] md:text-left font-bold text-sm sm:text-2xl">Moving services</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/home-repairs.png" alt="">
              </div>
              <h4 class="text-[#514D59] md:text-left font-bold text-sm sm:text-2xl">Home repairs</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/snow.png" alt="">
              </div>
              <h4 class="text-[#514D59] md:text-left font-bold text-sm sm:text-2xl">Snow removal</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/electrical.png" alt="">
              </div>
              <h4 class="text-[#514D59] md:text-left font-bold text-sm sm:text-2xl">Electrical work</h4>
            </div>
            <div class="flex space-x-4 flex-col sm:flex-row items-center ">
              <div class="bg-[#BFFBDC] p-3 rounded-lg hover:scale-110 transition-all duration-200 cursor-pointer">
                <img src="@/assets/landing/tool.png" alt="">
              </div>
              <h4 class="text-[#514D59] md:text-left font-bold text-sm sm:text-2xl">and more...</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- =========== -->

  <section class="bg-[#BFFBDC]">
    <div class="max-w-7xl mx-auto py-10">
      <div class="flex flex-col md:flex-row justify-evenly items-center">
        <p class="text-3xl mb-4 md:mb-0">Available soon on the:</p>
        <img src="@/assets/landing/apple-store.png" alt="" class=" md:h-auto">
        <img src="@/assets/landing/google-play.png" alt="" class=" md:h-auto">
      </div>
    </div>
  </section>

  <!-- =========== -->
  <section class="bg-[#2BC7AE] py-24 px-4 md:px-0">
    <div class="max-w-7xl  mx-auto">
      <h1 class="text-white text-center text-6xl  mb-8 pb-8 font-bold">FAQ's</h1>
      <div class="grid md:grid-cols-2 gap-16 align-top">

        <div class="text-white flex flex-col space-y-4">
          <div class="flex space-x-2 items-baseline">
            <h4 class="text-xl md:text-4xl font-semibold">1.</h4>
            <h4 class="text-xl md:text-4xl font-semibold ">What is HuskyTask and how does it work?</h4>
          </div>
          <p class="text-sm md:text-xl">
            HuskyTask is an online task management platform that connects skilled service providers, or “taskers,” to
            homeowners in Halifax, Nova Scotia. Our platform allows taskers the flexibility to find jobs in their local
            area, set their own rates, and manage their own schedules.
          </p>
        </div>

        <div class="text-white flex flex-col space-y-4">
          <div class="flex space-x-2 items-baseline">
            <h4 class="text-xl md:text-4xl font-semibold">2.</h4>
            <h4 class="text-xl md:text-4xl font-semibold ">What types of tasks are available on HuskyTask?</h4>
          </div>
          <p class=" text-sm md:text-xl">
            You can choose from a variety of tasks, including handyman services, home repairs, runnings errands, moving
            services, assembling furniture, and more. Taskers can choose gigs based on their expertise and interests.
          </p>
        </div>

        <div class="text-white flex flex-col space-y-4">
          <div class="flex space-x-2 items-baseline">
            <h4 class="text-xl md:text-4xl font-semibold">3.</h4>
            <h4 class="text-xl md:text-4xl font-semibold ">How do I become a tasker?</h4>
          </div>
          <p class=" text-sm md:text-xl">
            Become a tasker by completing the registration process on our website. By signing up, you’ll be among the
            first to secure a spot on our short-term waitlist and receive all the details you need to kickstart your
            journey as a tasker once our platform is live. No need to wait long; our launch is just around the corner!
          </p>
        </div>

        <div class="text-white flex flex-col space-y-4">
          <div class="flex space-x-2 items-baseline">
            <h4 class="text-xl md:text-4xl font-semibold">4.</h4>
            <h4 class="text-xl md:text-4xl font-semibold ">How do I get paid for completing tasks?</h4>
          </div>
          <p class=" text-sm md:text-xl">
            Once you successfully complete a task, you will receive direct payment from the customer. HuskyTask does not
            deduct any portion of your earnings. You determine your own rate, taking into account factors such as the
            type of the job, level of experience, and desired income.</p>
        </div>

        <div class="text-white flex flex-col space-y-4">
          <div class="flex space-x-2 items-baseline">
            <h4 class="text-xl md:text-4xl font-semibold">5.</h4>
            <h4 class="text-xl md:text-4xl font-semibold ">I have a full-time job. Can I work as a tasker on the side?</h4>
          </div>
          <p class=" text-sm md:text-xl">
            Absolutely! HuskyTask is designed to provide flexibility, allowing taskers to work part-time based on their
            availability. You have the freedom to choose the tasks and hours that suit your lifestyle.</p>
        </div>

        <div class="text-white flex flex-col space-y-4">
          <div class="flex space-x-2 items-baseline">
            <h4 class="text-xl md:text-4xl font-semibold">6.</h4>
            <h4 class="text-xl md:text-4xl font-semibold ">How much does it cost to sign up?</h4>
          </div>
          <p class=" text-sm md:text-xl">
            Signing up for HuskyTask is completely free of charge for both taskers and customers. There are no upfront
            costs or fees associated with creating an account and becoming a member of the platform.</p>
        </div>

      </div>
    </div>
  </section>
  <!-- =========== -->

  <section class="py-20 text-center md:text-left px-4 md:px-0">
    <div class="max-w-7xl mx-auto">
      <div class="grid items-center md:grid-cols-12 gap-x-10">
        <div class="col-span-6">
          <div class="flex flex-col space-y-4">
            <h1 class="text-[#23C6AC] text-4xl md:text-6xl  font-bold">Ready to get started?</h1>
            <h4 class="text-[#625F67] text-base md:text-4xl">Don’t miss out on the chance to boost your income with HuskyTask!
            </h4>
          </div>
        </div>
        <div class="col-span-6">
          <div class="flex justify-center pt-4 md:pt-0 md:justify-end">
            <a href="/register" class="bg-[#FFA500] text-white px-16 py-4 rounded-full shadow-xl font-bold text-4xl md:text-5xl">Join
              Now</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- =========== -->

  <section class="bg-[#333333] md:py-20 py-10 px-4 md:px-0">
    <div class="max-w-7xl mx-auto">
      <div class="grid md:grid-cols-12 text-center md:text-justify gap-10">
        <div class="order-2 md:order-1 col-span-6">
          <img src="@/assets/landing/husky-white.png" class="-ml-2" alt="">
          <div class="flex justify-center md:justify-normal space-x-2 sm:pl-8 mt-4">
            <a href="">
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
                <g clip-path="url(#clip0_1_58)">
                  <path
                    d="M21.1314 7.77101C20.8742 7.77101 20.6228 7.84728 20.4089 7.99018C20.1951 8.13308 20.0283 8.33619 19.93 8.57382C19.8315 8.81146 19.8057 9.07294 19.8559 9.32521C19.9061 9.57749 20.0299 9.80922 20.2118 9.9911C20.3937 10.173 20.6255 10.2968 20.8777 10.347C21.13 10.3972 21.3914 10.3714 21.6291 10.273C21.8668 10.1746 22.0699 10.0079 22.2128 9.79403C22.3557 9.58016 22.4319 9.32872 22.4319 9.07151C22.4321 8.72579 22.2983 8.39346 22.0586 8.1443C21.9398 8.01931 21.7955 7.92131 21.6356 7.8569C21.4756 7.7925 21.3037 7.76321 21.1314 7.77101Z"
                    fill="#FAFAFA" />
                  <path
                    d="M24.3706 5.83221C23.1273 4.69782 21.5019 4.07428 19.8189 4.08617C18.9639 4.01392 17.5069 4.01392 15.3514 4.01392C13.196 4.01392 11.7389 4.01392 10.884 4.08617C9.20097 4.07428 7.57548 4.69782 6.33221 5.83221C5.19962 7.07179 4.57613 8.69287 4.58617 10.3719C4.538 11.2068 4.51392 12.7 4.51392 14.8515C4.51392 17.0069 4.51392 18.464 4.58617 19.3189C4.57427 21.0018 5.19781 22.6274 6.33221 23.8706C7.57548 25.005 9.20097 25.6286 10.884 25.6167C11.7389 25.6889 13.196 25.6889 15.3514 25.6889C17.5069 25.6889 18.9639 25.6889 19.8189 25.6167C21.5019 25.6286 23.1273 25.005 24.3706 23.8706C25.505 22.6274 26.1285 21.0018 26.1167 19.3189C26.1889 18.464 26.1889 17.0069 26.1889 14.8515C26.1889 12.696 26.1889 11.2389 26.1167 10.3719C26.1267 8.69287 25.5032 7.07179 24.3706 5.83221ZM24.2502 15.9352V17.4163C24.2502 17.7535 24.2502 18.2111 24.2502 18.7771C24.2365 19.2649 24.1923 19.7516 24.1177 20.2341C24.0608 20.5787 23.972 20.9173 23.8528 21.2456C23.6594 21.7108 23.3726 22.1315 23.0101 22.4815C22.6477 22.8315 22.2173 23.1035 21.7455 23.2806C21.4172 23.3998 21.0786 23.4886 20.734 23.5454C20.2516 23.62 19.765 23.6643 19.277 23.6779H17.9163H12.7865H11.4258C10.9379 23.6643 10.4512 23.62 9.96879 23.5454C9.62418 23.4886 9.28558 23.3998 8.95729 23.2806C8.49889 23.0953 8.08248 22.8195 7.73286 22.4699C7.38324 22.1203 7.10757 21.704 6.92225 21.2456C6.80299 20.9173 6.7143 20.5787 6.65733 20.2341C6.5828 19.7516 6.53856 19.2649 6.52487 18.7771C6.52487 18.2111 6.52487 17.7535 6.52487 17.4163V15.9352C6.52487 15.2729 6.52487 14.9117 6.52487 14.8515C6.52487 14.7913 6.52487 14.43 6.52487 13.7677V12.2865C6.52487 11.9494 6.52487 11.4918 6.52487 10.9258C6.53856 10.4379 6.5828 9.95123 6.65733 9.46879C6.7143 9.12419 6.80299 8.78558 6.92225 8.45729C7.10757 7.99889 7.38324 7.58249 7.73286 7.23287C8.08248 6.88325 8.49889 6.60757 8.95729 6.42225C9.28558 6.30299 9.62418 6.2143 9.96879 6.15733C10.4512 6.0828 10.9379 6.03857 11.4258 6.02487H12.7865H17.9163H19.277C19.765 6.03857 20.2516 6.0828 20.734 6.15733C21.0786 6.2143 21.4172 6.30299 21.7455 6.42225C22.2039 6.60757 22.6204 6.88325 22.97 7.23287C23.3196 7.58249 23.5952 7.99889 23.7806 8.45729C23.8998 8.78558 23.9885 9.12419 24.0455 9.46879C24.1201 9.95123 24.1642 10.4379 24.178 10.9258C24.178 11.4918 24.178 11.9494 24.178 12.2865V13.7677C24.178 14.43 24.178 14.7913 24.178 14.8515C24.178 14.9117 24.2382 15.2729 24.2502 15.9352Z"
                    fill="#FAFAFA" />
                  <path
                    d="M15.3514 9.2881C14.6203 9.28652 13.8962 9.42933 13.2205 9.70836C12.5448 9.98737 11.9309 10.3971 11.414 10.914C10.8971 11.4309 10.4874 12.0448 10.2084 12.7205C9.92934 13.3962 9.78653 14.1204 9.7881 14.8513C9.78653 15.5823 9.92934 16.3065 10.2084 16.9822C10.4874 17.6579 10.8971 18.2718 11.414 18.7887C11.9309 19.3056 12.5448 19.7153 13.2205 19.9944C13.8962 20.2734 14.6203 20.4162 15.3514 20.4146C16.0824 20.4162 16.8065 20.2734 17.4822 19.9944C18.1579 19.7153 18.7718 19.3056 19.2887 18.7887C19.8056 18.2718 20.2153 17.6579 20.4944 16.9822C20.7734 16.3065 20.9162 15.5823 20.9146 14.8513C20.9162 14.1204 20.7734 13.3962 20.4944 12.7205C20.2153 12.0448 19.8056 11.4309 19.2887 10.914C18.7718 10.3971 18.1579 9.98737 17.4822 9.70836C16.8065 9.42933 16.0824 9.28652 15.3514 9.2881ZM17.9042 17.4041C17.2194 18.0423 16.3136 18.3897 15.3778 18.3732C14.4418 18.3566 13.5489 17.9775 12.8871 17.3156C12.2252 16.6537 11.8461 15.7609 11.8295 14.825C11.813 13.8891 12.1604 12.9833 12.7985 12.2985C13.4759 11.622 14.3941 11.242 15.3514 11.242C16.3087 11.242 17.2269 11.622 17.9042 12.2985C18.5807 12.9758 18.9607 13.894 18.9607 14.8513C18.9607 15.8086 18.5807 16.7268 17.9042 17.4041Z"
                    fill="#FAFAFA" />
                </g>
                <defs>
                  <clipPath id="clip0_1_58">
                    <rect width="30.1042" height="30.1042" fill="white" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a href="">
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
                <g clip-path="url(#clip0_1_51)">
                  <path
                    d="M12.8668 25.6936H16.8646V15.8074H20.1881L20.7059 11.954H16.8646V9.5457C16.8297 9.0442 16.9702 8.54616 17.262 8.13682C17.4635 7.9444 17.7052 7.79919 17.9696 7.71172C18.2342 7.62425 18.5148 7.5967 18.7913 7.63107H20.8384V4.18715C19.8483 4.05822 18.8503 4.00187 17.852 4.01857C17.1912 3.98996 16.5315 4.09343 15.9111 4.32294C15.2909 4.55245 14.7226 4.90338 14.2395 5.3552C13.7643 5.85313 13.3971 6.44386 13.1609 7.09036C12.9247 7.73687 12.8245 8.42519 12.8668 9.1122V11.954H9.53125V15.8074H12.8668V25.6936Z"
                    fill="#FAFAFA" />
                </g>
                <defs>
                  <clipPath id="clip0_1_51">
                    <rect width="30.1042" height="30.1042" fill="white" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div class="order-1 md:order-2 col-span-6">
          <div class="flex flex-col md:items-end  text-white mt-4">
            <p class="pb-8 font-bold text-xl md:text-3xl">
              Have questions? We’re here to help!
            </p>
            <p class=" text-base md:text-3xl">
              Contact us at info@huskytask.com
            </p>
            <p class="text-base md:text-3xl">We look forward to hearing from you!
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<script></script>
<style scoped>

  .header-img-bg{
    background: url('./../assets/landing/tasker.png'), lightgray 40% / cover no-repeat;
  }
  .shape-bg{
    background-image: url('./../assets/landing/shape-bg.png');
  }
  .form-bg-img{
    background-image: url('./../assets/landing/image-bg-form.png'); background-size: cover; background-position: center left;
  }
  .drill::before {
    background-image: url('./../assets/landing/drill.png');
    content: '';
    height: 200px;
    width: 270px;
    display: inline-block;
    background-repeat: no-repeat;
    position: relative;
    top: -20%;
    transform: rotate(14deg);
    z-index: -2;

}

.drill::before {
  @apply hidden xl:block;
}
</style>
